import {
  WebchatError,
  NETWORK_ERROR,
  SSE_DISCONNECTED_ERROR,
  webhookHandlerErrorMap,
  commonApiErrorMap,
  isIntegrationError,
  isWebhookHandlerErrorType,
  isCommonApiErrorType,
  isEventError,
  INVALID_MESSAGE_CONTENT_TYPE,
} from '../types'

const NETWORK_ERROR_MESSAGES = ['networkerror', 'failedtofetch', 'errorininputstream']

export const mapToWebchatError = (thrown: unknown): WebchatError => {
  console.error('An error occurred:', thrown)

  let webchatError: WebchatError = {
    type: 'unknown',
    message: 'An unexpected error occurred',
  }

  if (isIntegrationError(thrown)) {
    if (thrown.type === 'network') {
      webchatError = {
        id: thrown.id,
        type: 'network',
        message: NETWORK_ERROR,
      }
    } else if (thrown.message?.includes('[Webhook Handler]') && isWebhookHandlerErrorType(thrown.type)) {
      webchatError = { id: thrown.id, ...webhookHandlerErrorMap[thrown.type] }
    } else if (isCommonApiErrorType(thrown.type)) {
      webchatError = { id: thrown.id, ...commonApiErrorMap[thrown.type] }
    } else {
      webchatError = {
        id: thrown.id,
        type: thrown.type,
        message: thrown.message || 'An error occurred',
      }
    }
  } else if (isEventError(thrown)) {
    if (isNetworkError(thrown.message)) {
      webchatError = {
        type: 'disconnected',
        message: SSE_DISCONNECTED_ERROR,
      }
    } else if (normalizeMessage(thrown.message).includes('invalidcontenttype')) {
      webchatError = {
        type: 'bot',
        message: INVALID_MESSAGE_CONTENT_TYPE,
      }
    } else {
      webchatError = {
        type: 'event',
        message: thrown.message,
      }
    }
  } else if (thrown instanceof Error && isNetworkError(thrown.message)) {
    webchatError = {
      type: 'network',
      message: NETWORK_ERROR,
    }
  } else if (thrown && typeof thrown === 'object' && 'type' in thrown && 'message' in thrown) {
    const webchatErr = thrown as { type: string; message: string }
    if (webchatErr.type === 'network') {
      webchatError = {
        type: 'network',
        message: NETWORK_ERROR,
      }
    } else {
      webchatError = {
        type: webchatErr.type,
        message: webchatErr.message,
      }
    }
  }

  return webchatError
}

function isNetworkError(message: string): boolean {
  return NETWORK_ERROR_MESSAGES.some((m) => normalizeMessage(message).includes(m))
}

function normalizeMessage(message: string): string {
  return message.replaceAll(' ', '').toLowerCase()
}
